




























import { Prop, Component, Vue } from "vue-property-decorator";
import { Question } from "@/api/minutes-api";
import Action from "@/models/action";
import VToolbar from "../components/VToolbar.vue";

@Component({
  components: {
    VToolbar
  }
})
export default class MinuteTypeList extends Vue {
  @Prop({ default: () => [] }) actions!: Action[];
  @Prop({ default: () => [] }) questions!: Question[];
}
